/**
 * Stories for 404 handle this
 */
/* eslint-disable local-rules/require-storybook-documentation */

import { Box } from '@zillow/constellation-10';

export const ContentWrapper = ({ children }: { children: React.ReactNode }) => (
    <Box
        css={{
            width: '{breakpoints.xxl}',
            maxWidth: '100%',
            margin: '0 auto',
            padding: { base: 'sm' },
            paddingTop: 'xl',
            textAlign: 'left',
            zIndex: 2,
            position: { lg: 'absolute' },
            top: { lg: 0 },
            left: { lg: '50%' },
            transform: { lg: 'translateX(-50%)' },
        }}>
        {children}
    </Box>
);
